/**
 * URL search-param serialization for 訪問予定表(施術師毎) — /visits/massager_init.
 *
 * Dates stored as ISO (YYYY-MM-DD) in the URL; the form still displays 和暦.
 * `run=1` marks that the page should auto-run the search on load.
 */

import { convGtJDate, dateValueToIso } from '@/utils/dateConverter';
import type { MassagerSearchFormValues } from './components/HomeVisitMassagerSearchForm';
import type { HomeVisitMassagerSearchParams } from './types';

export function formValuesToSearchParams(
  values: MassagerSearchFormValues,
  payload: HomeVisitMassagerSearchParams
): URLSearchParams {
  const qs = new URLSearchParams();
  qs.set('run', '1');
  qs.set('visit_date_from', payload.visit_date_from);
  qs.set('visit_date_to', payload.visit_date_to);
  if (values.massagerRadio === '2' && payload.massager_id != null) {
    qs.set('massager_radio', '2');
    qs.set('massager_id', String(payload.massager_id));
  }
  return qs;
}

export function searchParamsToFormValues(
  urlSearchParams: URLSearchParams
): MassagerSearchFormValues | null {
  if (urlSearchParams.get('run') !== '1') return null;

  const toWareki = (iso: string | null): string => (iso ? convGtJDate(iso) : '');
  const intOrNull = (raw: string | null): number | null => {
    if (raw == null || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  };

  const massagerRadio = urlSearchParams.get('massager_radio') === '2' ? '2' : '1';
  const massagerId = massagerRadio === '2' ? intOrNull(urlSearchParams.get('massager_id')) : null;

  return {
    visitDateFrom: toWareki(urlSearchParams.get('visit_date_from')),
    visitDateTo: toWareki(urlSearchParams.get('visit_date_to')),
    massagerRadio,
    massagerId,
  };
}

export function formValuesToSearchPayload(
  values: MassagerSearchFormValues
): HomeVisitMassagerSearchParams {
  const payload: HomeVisitMassagerSearchParams = {
    visit_date_from: dateValueToIso(values.visitDateFrom) ?? '',
    visit_date_to: dateValueToIso(values.visitDateTo) ?? '',
  };
  if (values.massagerRadio === '2' && values.massagerId) {
    payload.massager_id = values.massagerId;
  }
  return payload;
}
